export default {
  // used in conjunction with CELL_ACTIONS
  ACTION: 'action',
  // default cell type
  VALUE: 'value',
  // can contain anything, cannot be removed by "customize columns"
  // (currently only used for checkboxes)
  ALWAYS_ACTIVE: 'always_active'
};
